export default "__VITE_ASSET__sdcW2HGD__"